import React from "react";

export const verdictExplanation = (
  <div>
    <p>
      This summary line displays the exact number of unique submissions that
      have classified the variant as pathogenic, likely pathogenic, of uncertain
      significance, likely benign or benign.
    </p>
  </div>
);
